import React from 'react';
import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, title, listBox, gridContainer, digiBox, digiHeaderImg } from './LastPageStyle';
import imgDigi1 from '../../assets/media/digi1.png';
import imgDigi2 from '../../assets/media/digi2.png';
import imgDigi3 from '../../assets/media/digi3.png';
import imgDigi4 from '../../assets/media/digi4.png';

const DigitalMaturityLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>Mit ZMC und Digitalisierung zu profitablem Wachstum</div>
                <h2>Wir navigieren Sie zielgerichtet durch die digitale Transformation</h2>
                <p>
                    Dazu bieten wir umfassende Beratungs-, Umsetzungs- &amp; Trainings- sowie Durchführungsleistungen
                    auf dem Weg zu Digitalisierung/Industrie 4.0.
                </p>
                <div className={gridContainer}>
                    <div className={digiBox}>
                        <img className={digiHeaderImg} src={imgDigi1} alt="Licht" />
                        <div className={listBox}>
                            <b>Digitale Befähigung</b>
                            <ul>
                                <li>Digital Leadership</li>
                                <li>Agile Organisation</li>
                                <li>Digitale Fähigkeiten und Kultur</li>
                                <li>Agile, digitale Methoden und Vorgehensweisen</li>
                                <li>Digital Bootcamp</li>
                                <li>InnovationLab@ZMC</li>
                            </ul>
                        </div>
                    </div>
                    <div className={digiBox}>
                        <img className={digiHeaderImg} src={imgDigi2} alt="Netzwerk" />
                        <div className={listBox}>
                            <b>Digitale Supply Chain und Prozesse</b>
                            <ul>
                                <li>End to End Supply Chain-Integration</li>
                                <li>Smart Supply Chain, Supply Chain 4.0</li>
                                <li>Simulation, digitaler Supply Chain Zwilling</li>
                                <li>Geschäftsprozessoptimierung, digitale Geschäftsprozesse</li>
                                <li>Nutzungsoptimierung von Geschäftsapplikationen</li>
                                <li>Integrated Business Planning</li>
                                <li>E-Procurement</li>
                                <li>Digital Procurement, Procurement 4.0</li>
                                <li>Smart Factory, Industrie 4.0, Smart Logistics</li>
                                <li>Digital Service, Service 4.0</li>
                            </ul>
                        </div>
                    </div>
                    <div className={digiBox}>
                        <img className={digiHeaderImg} src={imgDigi3} alt="Analyse" />
                        <div className={listBox}>
                            <b>Digitales Geschäft</b>
                            <ul>
                                <li>Potenzial- und Risikoanalyse</li>
                                <li>Readiness &amp; Maturity Assessment</li>
                                <li>Digital Booster Pack: Take off, Ideation, Disruption</li>
                                <li>Digitale Strategieentwicklung</li>
                                <li>Digitale Investitions- und Transformations-Roadmap</li>
                                <li>Customer Journey Review</li>
                                <li>Digitale, innovative Geschäftsmodelle</li>
                                <li>Digitale Plattformstrategien</li>
                                <li>Digitale, smarte Produkte und Dienstleistungen</li>
                                <li>Go to market-Konzepte</li>
                            </ul>
                        </div>
                    </div>
                    <div className={digiBox}>
                        <img className={digiHeaderImg} src={imgDigi4} alt="Cloud" />
                        <div className={listBox} style={{ height: '100%' }}>
                            <b>Big Data &amp; Digitale Technologie</b>
                            <ul>
                                <li>360°IT Assessment</li>
                                <li>Applikations-Architektur, IT-Bebauungsplan</li>
                                <li>Agile Geschäftsapplikationsevaluation</li>
                                <li>Big Data &amp; Digital Technology Inventory</li>
                                <li>Big Data Analytics, Data Science</li>
                                <li>DevOps-Konzepte</li>
                                <li>Technology Scouting</li>
                                <li>Feasibility, Evaluation von digitalen, disruptiven Technologien</li>
                                <li>Prototyping, Piloten für digitale Lösungen</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <h2>Namhafte Kunden vertrauen uns seit über 25 Jahren</h2>
                <p>
                    Nationale und internationale Unternehmen aus den Sektoren Industrie sowie schnell drehende
                    Konsumgüter (FMCG) vertrauen uns als Navigator in der digitalen Transformation sowie durch die
                    vierte industrielle Revolution.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default DigitalMaturityLastPage;
